import { Trans } from '@lingui/react/macro'

import { Suspense } from '@/components/ui/Suspense'
import { CheckPermission, Permission } from '@/features/auth'
import { FeatureSelector } from '@/features/integrations'
import { useEffect } from 'react'

function Integrations() {
  return (
    <div>
      <h1 className="text-heading1 text-text">
        <Trans>Integrations</Trans>
      </h1>
      <FeatureSelector />
    </div>
  )
}

export default function SuspenseIntegrations() {
  // This is needed for the PopupLinkComponent so that the redirect from the server actually just closes the PopUp
  useEffect(() => {
    if (!window.opener) return

    window.opener.postMessage(
      { type: 'POPUP_COMPLETE' },
      window.location.origin
    )

    window.close()
  })

  return (
    <CheckPermission
      permissions={[Permission.ORG_UPDATE]}
      redirect={'/goodies'}
    >
      <Suspense>
        <Integrations />
      </Suspense>
    </CheckPermission>
  )
}
